@file:OptIn(InternalResourceApi::class)

package mobile_wallet.feature.savedcards.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String =
    "composeResources/mobile_wallet.feature.savedcards.generated.resources/"

internal val Res.drawable.amex_logo: DrawableResource by lazy {
      DrawableResource("drawable:amex_logo", setOf(
        ResourceItem(setOf(), "${MD}drawable/amex_logo.xml", -1, -1),
      ))
    }

internal val Res.drawable.bg1: DrawableResource by lazy {
      DrawableResource("drawable:bg1", setOf(
        ResourceItem(setOf(), "${MD}drawable/bg1.xml", -1, -1),
      ))
    }

internal val Res.drawable.bg2: DrawableResource by lazy {
      DrawableResource("drawable:bg2", setOf(
        ResourceItem(setOf(), "${MD}drawable/bg2.xml", -1, -1),
      ))
    }

internal val Res.drawable.bg3: DrawableResource by lazy {
      DrawableResource("drawable:bg3", setOf(
        ResourceItem(setOf(), "${MD}drawable/bg3.xml", -1, -1),
      ))
    }

internal val Res.drawable.bg4: DrawableResource by lazy {
      DrawableResource("drawable:bg4", setOf(
        ResourceItem(setOf(), "${MD}drawable/bg4.xml", -1, -1),
      ))
    }

internal val Res.drawable.circle_bg: DrawableResource by lazy {
      DrawableResource("drawable:circle_bg", setOf(
        ResourceItem(setOf(), "${MD}drawable/circle_bg.xml", -1, -1),
      ))
    }

internal val Res.drawable.diner_clubs: DrawableResource by lazy {
      DrawableResource("drawable:diner_clubs", setOf(
        ResourceItem(setOf(), "${MD}drawable/diner_clubs.xml", -1, -1),
      ))
    }

internal val Res.drawable.ic_mastercard: DrawableResource by lazy {
      DrawableResource("drawable:ic_mastercard", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_mastercard.xml", -1, -1),
      ))
    }

internal val Res.drawable.ic_visa: DrawableResource by lazy {
      DrawableResource("drawable:ic_visa", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_visa.xml", -1, -1),
      ))
    }

internal val Res.drawable.maestro: DrawableResource by lazy {
      DrawableResource("drawable:maestro", setOf(
        ResourceItem(setOf(), "${MD}drawable/maestro.xml", -1, -1),
      ))
    }

internal val Res.drawable.red_bg: DrawableResource by lazy {
      DrawableResource("drawable:red_bg", setOf(
        ResourceItem(setOf(), "${MD}drawable/red_bg.xml", -1, -1),
      ))
    }

internal val Res.drawable.rupay_logo: DrawableResource by lazy {
      DrawableResource("drawable:rupay_logo", setOf(
        ResourceItem(setOf(), "${MD}drawable/rupay_logo.xml", -1, -1),
      ))
    }

internal val Res.drawable.symbol: DrawableResource by lazy {
      DrawableResource("drawable:symbol", setOf(
        ResourceItem(setOf(), "${MD}drawable/symbol.xml", -1, -1),
      ))
    }

internal val Res.drawable.violet_bg: DrawableResource by lazy {
      DrawableResource("drawable:violet_bg", setOf(
        ResourceItem(setOf(), "${MD}drawable/violet_bg.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("amex_logo", Res.drawable.amex_logo)
  map.put("bg1", Res.drawable.bg1)
  map.put("bg2", Res.drawable.bg2)
  map.put("bg3", Res.drawable.bg3)
  map.put("bg4", Res.drawable.bg4)
  map.put("circle_bg", Res.drawable.circle_bg)
  map.put("diner_clubs", Res.drawable.diner_clubs)
  map.put("ic_mastercard", Res.drawable.ic_mastercard)
  map.put("ic_visa", Res.drawable.ic_visa)
  map.put("maestro", Res.drawable.maestro)
  map.put("red_bg", Res.drawable.red_bg)
  map.put("rupay_logo", Res.drawable.rupay_logo)
  map.put("symbol", Res.drawable.symbol)
  map.put("violet_bg", Res.drawable.violet_bg)
}
